import { setErrorHandler } from '@stencil/core'

export default function () {
  setErrorHandler((error, _) => {
    // eslint-disable-next-line no-console
    console.error(error) // Default behavior
    if (error instanceof Error) {
      window.Sentry?.captureException(error)
    }
  })
}
